import { Stack, Typography, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./AddArtists.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useDispatch, useSelector } from "react-redux";
import { dashboardRedux } from "../../../../redux/dashboard-redux/DashboardRedux";
import MuiGradientTabs from "../../../../components/common/mui-tabs/gradient-tabs/MuiGradientTabs";
import ImageAssets from "../../../../assets";
import CustomAvatar from "../../../../components/common/avatar/MuiAvatar";
import { MuiButton } from "../../../../components/common/button/MuiButton";
import { MuiAutocomplete } from "../../../../components/common/dropdown/mui-autocomplete/MuiAutocomplete";
import { MuiTextField } from "../../../../components/common/textfield/MuiTextField";
import strings from "../../../../strings/Strings";
import { createProjectRedux } from "../../../../redux/create-project-redux/CreateProjectRedux";
import { CapitalizeString } from "../../../../utils/CapitalizeString";
import { CircularLoader } from "../../../../components/common/loaders/CircularLoader";
import { useLocation, useNavigate } from "react-router";
import { RevenueShareTypeEnum } from "../../../../core/enumerations/RevenueShareTypeEnum";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import MuiMenu from "../../../../components/common/menu/Menu";
import { ThemeEnum } from "../../../../core/enumerations/ThemeEnum";
import { MenuItemStyles } from "../../../blogs/BlogsWrapper.style";
import { getLocalStorageItem } from "../../../../utils/LocalStorage";
import { getCookies } from "../../../../utils/Cookies";

const AddArtists = (props: any) => {
  const tabData = [
    {
      id: 1,
      name: "Add artist",
      value: "Add artist",
    },
    {
      id: 2,
      name: "Project Requirements",
      value: "Project Requirements",
    },
  ];

  const actionDispatch = (dispatch: any) => ({
    setDashboardStates: (data: any) =>
      dispatch(dashboardRedux.actions.setDashboardState(data)),
    getUsersListBasedOnSkillId: (data: any) =>
      dispatch(
        createProjectRedux.actions.getUsersListBasedOnSkillIdRequest(data)
      ),
    inviteCollaborator: (data: any) =>
      dispatch(dashboardRedux.actions.inviteCollaboratorRequest(data)),
    getAllInvitedCollaborators: (data: any) =>
      dispatch(dashboardRedux.actions.getAllInvitedCollaboratorsRequest(data)),
  });

  const {
    setDashboardStates,
    getUsersListBasedOnSkillId,
    inviteCollaborator,
    getAllInvitedCollaborators,
  } = actionDispatch(useDispatch());
  const dashboardState = useSelector((state: any) => state.dashboardRedux);
  const createProjectState = useSelector(
    (state: any) => state.CreateProjectRedux
  );
  const [removeArtistsAnchorElement, setRemoveArtistsAnchorElement] =
    useState<null | HTMLElement>(null);
  const isOpenMoreMenu = Boolean(removeArtistsAnchorElement);
  const loggedInUserDetails: any = getCookies("userDetails");

  const location = useLocation();
  const navigate = useNavigate();

  const [tabValue, setTabValue] = useState<Number>(0);
  const selectedSkillId = props.skillId
    ? props.skillId
    : location?.state?.skillId;

  useEffect(() => {
    if (!props.skillId) {
      getUsersListBasedOnSkillId({
        skillId: location?.state?.skillId,
        userId: JSON.parse(loggedInUserDetails)?.id,
      });
      getAllInvitedCollaborators({
        skillId: location?.state?.skillId,
        projectId: location?.state?.projectId,
      });
    }
  }, []);

  // useEffect(() => {
  //   if (dashboardState.isInvitedArtistsFetched) {
  //     setDashboardStates({
  //       key: "collaboratorRequirements",
  //       value: dashboardState.collaboratorRequirements.map((artistRequirement: any) => selectedSkillId === artistRequirement.skillId ? {
  //         ...artistRequirement,
  //         alreadyInvitedArtists: [...dashboardState?.invitedArtistsForAProject?.responseData],
  //         invitedArtists: [
  //           ...dashboardState?.invitedArtistsForAProject?.responseData.filter((item: any) =>
  //             !artistRequirement?.invitedArtists?.map((artistData: any) => artistData?.userId).includes(item?.userId)
  //           ),
  //           ...artistRequirement?.invitedArtists
  //         ]
  //       } : {
  //         ...artistRequirement
  //       })
  //     })
  //     setDashboardStates({
  //       key: "isInvitedArtistsFetched", value: false
  //     })
  //   }
  // }, [dashboardState.isInvitedArtistsFetched])

  const handleTabChange = (event: React.SyntheticEvent, value: Number) => {
    setTabValue(value);
  };

  const handleTermsChange = (e: any, index: any) => {
    const { value } = e.target;
    const collaboratorRequirements =
      dashboardState?.collaboratorRequirements.map((artist: any) =>
        artist.skillId === selectedSkillId
          ? {
            ...artist,
            artistRequirements: artist.artistRequirements.map(
              (data: any, i: any) =>
                i === index ? { ...data, term: value } : { ...data }
            ),
          }
          : { ...artist }
      );
    setDashboardStates({
      key: "collaboratorRequirements",
      value: collaboratorRequirements,
    });
  };
  const handleAddAnotherTerm = () => {
    const collaboratorRequirements =
      dashboardState?.collaboratorRequirements?.map((artist: any, index: any) =>
        artist.skillId === selectedSkillId
          ? {
            ...artist,
            artistRequirements: [...artist.artistRequirements, { term: "" }],
          }
          : { ...artist }
      );
    setDashboardStates({
      key: "collaboratorRequirements",
      value: collaboratorRequirements,
    });
  };

  const handleDeleteTermField = (i: number) => {
    const collaboratorRequirements =
      dashboardState?.collaboratorRequirements?.map((artist: any, index: any) =>
        artist.skillId === selectedSkillId
          ? {
            ...artist,
            artistRequirements: [
              ...artist.artistRequirements.filter(
                (data: any, index: number) => i !== index
              ),
            ],
          }
          : { ...artist }
      );
    setDashboardStates({
      key: "collaboratorRequirements",
      value: collaboratorRequirements,
    });
  };

  const handleArtistsSelection = (values: any) => {
    let artists: any = [];
    values.forEach((item: any) => {
      artists.push({
        ...item,
      });
    });
    const collaboratorRequirements =
      dashboardState?.collaboratorRequirements?.map((artistType: any) => {
        if (artistType.skillId === selectedSkillId) {
          return {
            ...artistType,
            invitedArtists: [...artists],
          };
        } else {
          return {
            ...artistType,
          };
        }
      });
    setDashboardStates({
      key: "collaboratorRequirements",
      value: collaboratorRequirements,
    });
  };

  const handleDeleteArtist = (artistDtata: any) => {
    setDashboardStates({
      key: "collaboratorRequirements",
      value: dashboardState?.collaboratorRequirements?.map(
        (collaboratorRequirement: any) => {
          if (collaboratorRequirement.skillId === selectedSkillId) {
            return {
              ...collaboratorRequirement,
              invitedArtists: collaboratorRequirement?.invitedArtists?.filter(
                (artist: any) => artistDtata.userId !== artist.userId
              ),
            };
          } else {
            return {
              ...collaboratorRequirement,
            };
          }
        }
      ),
    });
  };

  const handleFetchArtistsDetailsBySkillId = (value: any) => {
    getUsersListBasedOnSkillId({
      skillId: selectedSkillId,
      artistName: value,
      userId: JSON.parse(loggedInUserDetails)?.id,
    });
  };

  const validateSharePercentage = (e: any, index: number) => {
    const inputValue = e.target.value;
    const validCharactersRegex = /[^0-9.]/g;
    const value = inputValue.replace(validCharactersRegex, "");

    let errorMessage: string = "";
    const parsedValue = parseFloat(value);
    // if (inputValue === "") {
    //   errorMessage = "Please enter a value"
    // }
    // else
    if (!isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 100) {
      errorMessage = "";
    } else {
      errorMessage = "Please enter a valid percentage";
    }

    return errorMessage;
  };

  const handleShareChange = (e: any, index: any) => {
    const inputValue = e.target.value;
    const validCharactersRegex = /[^0-9.]/g;
    const sanitizedValue = inputValue.replace(validCharactersRegex, "");
    const errorMessage = validateSharePercentage(e, index);

    const collaboratorRequirements =
      dashboardState?.collaboratorRequirements?.map((artistType: any) => {
        if (artistType.skillId === selectedSkillId) {
          return {
            ...artistType,
            invitedArtists: artistType.invitedArtists.map(
              (artistDetails: any, i: number) =>
                index === i
                  ? {
                    ...artistDetails,
                    shareInPercentage: sanitizedValue,
                    sharePercentageError: errorMessage,
                  }
                  : {
                    ...artistDetails,
                  }
            ),
          };
        } else {
          return {
            ...artistType,
          };
        }
      });
    setDashboardStates({
      key: "collaboratorRequirements",
      value: collaboratorRequirements,
    });
  };

  const handleClickOnMore = (event: React.MouseEvent<HTMLElement>) => {
    setRemoveArtistsAnchorElement(event.currentTarget);
  };

  const handleCloseMore = (artistData: any, index: number) => {
    handleDeleteArtist(artistData);
    setRemoveArtistsAnchorElement(null);
  };

  const validateForm = () => {
    let isValid = false;
    dashboardState?.collaboratorRequirements.every(
      (collaboratorRequirement: any) => {
        //To remove error key from invited artists to compare the data
        // const data = collaboratorRequirement.invitedArtists.map((artists: any) => {
        //   let newObj = { ...artists };
        //   if ("sharePercentageError" in newObj) {
        //     delete newObj["sharePercentageError"];
        //   }
        //   return newObj;
        // })

        // if (JSON.stringify(collaboratorRequirement.alreadyInvitedArtists) !== JSON.stringify(data)) {
        if (collaboratorRequirement.invitedArtists.length > 0) {
          if (
            location?.state?.revenueSplitType ===
            RevenueShareTypeEnum.unEqualSplit
          ) {
            collaboratorRequirement.invitedArtists.every((artist: any) => {
              if (!artist.shareInPercentage || artist.sharePercentageError) {
                isValid = false;
                return false;
              }
              return true;
            });
          } else {
            isValid = true;
            return false;
          }
        }

        return true;
      }
    );
    return isValid;
  };

  const handleInviteArtist = () => {
    inviteCollaborator({
      projectId: location?.state?.projectId,
      reqBody: dashboardState.collaboratorRequirements,
    });
  };

  const getSelectedData = () => {
    return dashboardState?.collaboratorRequirements?.find(
      (item: any) => item.skillId === selectedSkillId
    );
  };

  return (
    <Stack className={styles["artist-type-details-sub-container"]}>
      <Stack className={styles["mobile-header"]}>
        <ArrowBackIosRoundedIcon onClick={() => navigate(-1)} />
        {validateForm() ? (
          <Typography
            className={styles["save-and-next"]}
            onClick={handleInviteArtist}
          >
            {strings.saveAndNext}
          </Typography>
        ) : (
          <Typography className={styles["save-and-next-disabled"]}>
            {strings.saveAndNext}
          </Typography>
        )}
      </Stack>

      <div className={styles["skill-details"]}>
        <Typography>{CapitalizeString(getSelectedData()?.skill)}</Typography>
        <Typography>
          {getSelectedData()?.noOfArtistsRequired -
            getSelectedData()?.availableSlot}
          <span>/{getSelectedData()?.noOfArtistsRequired}</span>
        </Typography>
      </div>
      <MuiGradientTabs
        tabValue={tabValue}
        handleTabChange={handleTabChange}
        tabData={tabData}
      />

      {tabValue === 0 && (
        <>
          {dashboardState.isLoading ? (
            <CircularLoader />
          ) : (
            <Stack className={styles["form-container"]}>
              <MuiAutocomplete
                component={"project-details-add-artist"}
                value={getSelectedData()?.invitedArtists}
                dropdownData={
                  createProjectState.usersListBasedOnSkill?.responseData
                    ?.length > 0
                    ? createProjectState?.usersListBasedOnSkill?.responseData
                    : []
                }
                handleChange={handleArtistsSelection}
                backgroundColor="#000000"
                borderRadius="20px"
                fieldValue={"fullName"}
                fieldId={"userId"}
                isLoading={createProjectState?.isLoading}
                // maxSelectable={getSelectedData()?.availableSlot}
                handleInputChange={handleFetchArtistsDetailsBySkillId}
              />
              <Typography>{strings.inviteYourFriends} </Typography>
              <Grid container className={styles["cards-container"]}>
                {getSelectedData()?.invitedArtists.length > 0 &&
                  getSelectedData()?.invitedArtists?.map(
                    (artist: any, index: any) => (
                      <Grid item xs={12} md={10} lg={10} xl={5.7}>
                        <Stack className={styles["artists-card"]}>
                          <Stack justifyContent={"space-between"}>
                            <Stack
                              sx={{ position: "relative" }}
                              alignItems="center"
                              columnGap={1}
                            >
                              <CustomAvatar
                                numberOfAvatars={1}
                                imageAvatars={[
                                  { id: 1, imageUrl: artist.profilePic },
                                ]}
                                variant={"circular"}
                                sx={{ width: 30, height: 30 }}
                              />
                              <Typography className={styles["artist-name"]}>
                                {artist.fullName}
                              </Typography>
                              <Stack>
                                <img
                                  className={styles["ratings-icon"]}
                                  src={ImageAssets.ic_star}
                                  alt=""
                                />
                                <Typography
                                  className={styles["artist-ratings"]}
                                >
                                  4.8
                                </Typography>
                              </Stack>
                            </Stack>
                            {location?.state?.revenueSplitType ===
                              RevenueShareTypeEnum.unEqualSplit ? (
                              <>
                                <MoreHorizIcon
                                  className={styles["cancel-icon"]}
                                  onClick={(e: any) => handleClickOnMore(e)}
                                />
                                <MuiMenu
                                  open={isOpenMoreMenu}
                                  anchorEl={removeArtistsAnchorElement}
                                  handleClose={() =>
                                    handleCloseMore(artist, index)
                                  }
                                  selectedmenuoption={ThemeEnum.dark.toLowerCase()}
                                >
                                  <MenuItemStyles
                                    className="menu-items"
                                    onClick={() =>
                                      handleCloseMore(artist, index)
                                    }
                                  >
                                    Remove Artsit
                                  </MenuItemStyles>
                                </MuiMenu>
                              </>
                            ) : (
                              <CloseRoundedIcon
                                className={styles["cancel-icon"]}
                                onClick={() => handleDeleteArtist(artist)}
                              />
                            )}
                          </Stack>

                          {location?.state?.revenueSplitType ===
                            RevenueShareTypeEnum.unEqualSplit && (
                              <MuiTextField
                                fullWidth
                                type="text"
                                shouldDisplayError={true}
                                value={
                                  getSelectedData()?.invitedArtists[index]
                                    ?.shareInPercentage
                                }
                                onChange={(e: any) => handleShareChange(e, index)}
                                inputProps={{
                                  "data-testid": "title",
                                  maxLength: 60,
                                }}
                                label={strings.share}
                                errormessage={
                                  getSelectedData()?.invitedArtists[index]
                                    ?.sharePercentageError
                                    ? getSelectedData()?.invitedArtists[index]
                                      ?.sharePercentageError
                                    : ""
                                }
                              />
                            )}
                        </Stack>
                      </Grid>
                    )
                  )}
              </Grid>
            </Stack>
          )}
        </>
      )}
      {tabValue === 1 && (
        <div className={styles["add-terms-container"]}>
          <Typography className={styles["collaboration-trems"]}>
            {strings.collaborationTerms}
          </Typography>
          <Stack className={styles["terms-fields-container"]}>
            {getSelectedData()?.artistRequirements?.length > 0 &&
              getSelectedData()?.artistRequirements?.map(
                (data: any, index: any) => (
                  <Stack columnGap={1} sx={{ height: "52px" }}>
                    <MuiTextField
                      fullWidth
                      type="text"
                      // name={`collaboratorRequirements[${selectedArtistTypeIndex}].artistRequirements[${index}].term`}
                      onChange={(e: any) => handleTermsChange(e, index)}
                      inputProps={{ "data-testid": "title", maxLength: 60 }}
                      label={`Term${index + 1}`}
                      errormessage=""
                      value={data.term}
                      InputProps={
                        index > 0 && {
                          endAdornment: (
                            <img
                              style={{ cursor: "pointer" }}
                              src={ImageAssets.ic_cancel}
                              onClick={() => handleDeleteTermField(index)}
                            />
                          ),
                        }
                      }
                    />
                    {/* <DeleteOutlineRoundedIcon className={styles["delete-icon"]} onClick={() => arrayHelpers.remove(index)} /> */}
                  </Stack>
                )
              )}
          </Stack>
          <div className={styles["add-more"]}>
            <MuiButton
              startIcon={<AddIcon />}
              onClick={() => handleAddAnotherTerm()}
            >
              {strings.addTerm}
            </MuiButton>
          </div>
        </div>
      )}
    </Stack>
  );
};

export default AddArtists;
